import { Component, Input } from '@angular/core'

@Component({
  selector: 'spinner',
  templateUrl: './spinner.component.pug',
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent {
  @Input() text: string
}
